import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=cbb62188&"
import script from "./DataTable.vue?vue&type=script&lang=js&"
export * from "./DataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb62188')) {
      api.createRecord('cbb62188', component.options)
    } else {
      api.reload('cbb62188', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=cbb62188&", function () {
      api.rerender('cbb62188', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/table-card/DataTable.vue"
export default component.exports